import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.groupedBadgesByPosition, (position) => {
    return (_openBlock(), _createElementBlock("div", {
      key: position.name,
      class: _normalizeClass(["z-1 absolute flex flex-col gap-y-8 text-center text-12 font-medium text-white", $options.positionClasses[position.name]?.[$props.margin]])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.badges, (badge) => {
        return (_openBlock(), _createElementBlock("span", {
          key: badge.key,
          class: _normalizeClass(["badge badge-small badge-rounded", [_ctx.$attrs.class, badge.class]]),
          style: _normalizeStyle(badge.style)
        }, _toDisplayString(badge.text), 7))
      }), 128))
    ], 2))
  }), 128))
}